import usageActionTypes from './actionTypes';
import { createAsyncRequestReducer } from '../../util/fetchReducers';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../util/createReducer';
import { combineReducers } from 'redux';

const REPORTS_INITIAL_STATE = {
  isFetching: false,
  errors: null,
  responses: {},
};

const REPORT_DOWNLOADS_INITIAL_STATE = {
  urls: {},
};

export const reducers = {
  query: createAsyncRequestReducer(usageActionTypes.FETCH_USAGES),
  getDownloadUrl: createAsyncRequestReducer(
    usageActionTypes.FETCH_USAGE_REPORT_DOWNLOAD_URL,
  ),
  reports: createReducer(REPORTS_INITIAL_STATE, {
    [usageActionTypes.FETCH_USAGE_REPORTS_JSON_START]: (state: any) => ({
      ...state,
      isFetching: true,
      errors: null,
      responses: {},
    }),
    [usageActionTypes.FETCH_USAGE_REPORTS_JSON_SUCCESS]: (
      state: any,
      action: any,
    ) => ({
      ...state,
      isFetching: false,
      errors: null,
      responses: action.responses,
    }),
    [usageActionTypes.FETCH_USAGE_REPORTS_JSON_ERROR]: (
      state: any,
      action: any,
    ) => ({
      ...state,
      isFetching: false,
      errors: action.errors,
      responses: {},
    }),
  }),
  reportDownloads: createReducer(REPORT_DOWNLOADS_INITIAL_STATE, {
    [usageActionTypes.ADD_DOWNLOAD_URL_FOR_USAGE_REPORT]: (
      state: any,
      action: any,
    ) => {
      state.urls[action.reportLink] = action.downloadUrl;
      return {
        ...state,
        urls: state.urls,
      };
    },
  }),
};

export default combineReducers(reducers);
